// src/components/SubtitleControls.js

import React from 'react';

function SubtitleControls({ mode, setMode }) {
  return (
    <div className="subtitle-controls">
      <button
        className={`control-button ${mode === 'EN' ? 'active' : ''}`}
        onClick={() => setMode('EN')}
      >
        English
      </button>
      <button
        className={`control-button ${mode === 'JP' ? 'active' : ''}`}
        onClick={() => setMode('JP')}
      >
        日本語
      </button>
      <button
        className={`control-button ${mode === 'OFF' ? 'active' : ''}`}
        onClick={() => setMode('OFF')}
      >
        Off
      </button>
    </div>
  );
}

export default SubtitleControls;